import React from "react";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { useExpertDashboard, useExpertProfileContext } from "@limitless/expert";
import DashboardChart from "./DashboardChart";
import DashboardGraphHeader from "./DashboardGraphHeader";
import { useTheme } from "@mui/material/styles";

export const commonStyle = makeStyles(() => {
    return {
        container: {
            padding: "32px 32px 8px 32px",
            justifyContent: "center",
            alignItems: "center"
        }
    };
});

const DashboardRewards = () => {
    const classes = commonStyle();
    const { t } = useTranslation();
    const { getFormattedBalance } = useExpertProfileContext();
    const theme = useTheme();
    const {
        feesEarned,
        status,
        feeEarnedRate,
        currentMonthPloting,
        previousMonthPloting,
        categories,
        monthSuggestions,
        group,
        fetchMontlyData
    } = useExpertDashboard();

    React.useEffect(() => {
        if (Object.keys(monthSuggestions).length !== 0) {
            fetchMontlyData(monthSuggestions[0], group);
        }
    }, [monthSuggestions]);

    const series = React.useMemo(() => {
        return [
            {
                name: t("previous month"),
                data: previousMonthPloting
            },
            {
                name: t("this month"),
                data: currentMonthPloting
            }
        ];
    }, [currentMonthPloting, previousMonthPloting]);
    const options = {
        colors: [theme.palette.graph.yellow, theme.palette.graph.blue],
        fill: {
            type: "gradient",
            colors: ["#FFC369", theme.palette.primary.light],
            opacity: 0.33,
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.45,
                opacityTo: 0.05,
                stops: [20, 100, 100, 100]
            }
        },
        markers: {
            colors: ["transparent", theme.palette.graph.blue],
            strokeColors: ["transparent", theme.palette.background.elevation1],
            strokeWidth: 4,
            hover: {
                size: 8
            }
        }
    };

    return (
        <Grid container className={classes.container}>
            <DashboardGraphHeader
                title="Fees earned"
                fetchMontlyData={fetchMontlyData}
                leftTitle={getFormattedBalance(feesEarned)}
                status={status}
                rate={Math.abs(feeEarnedRate)?.toFixed(2)}
            />

            <Grid className="chart">
                <DashboardChart
                    series={series}
                    options={options}
                    inverseOrder
                    categories={categories}
                    tickAmount
                    chartType="area"
                />
            </Grid>
        </Grid>
    );
};

export default DashboardRewards;
